(ns frontend.view.modals.select-asset-type.view
  (:require
   [common.localization :as loc]
   [ui.components.modal.view :as modal]
   [ui.editors.labelled-input.view :as labelled-input]))

(defonce modal-key :select-asset-type-modal)

(defn view
  [{:keys [shown? close-modal! props state class-name topmost?]}]
  (let [{:keys [allowed-asset-types modal-title select-label on-select! on-cancel!]} props
        on-close! (fn [_]
                    (when (and (fn? on-cancel!)
                               (not (:selected-asset-type @state)))
                      (on-cancel!))
                    (close-modal!))
        disabled-button? (not (:selected-asset-type @state))]
    [modal/view
     {:visible?      (and shown? topmost?)
      :hide!         on-close!
      :backdrop      "static"
      :close-button? true}
     (or modal-title
         (loc/tr :select-target-asset-type))
     [:div
      [labelled-input/view
       {:editor-type   :editor.type/select
        :data-type     :data.type/keyword
        :label         (or select-label (loc/tr :asset-type))
        :mandatory?    true
        :is-clearable? false
        :value         (:selected-asset-type @state)
        :options       (->> allowed-asset-types
                            (mapv (fn [a]
                                    {:value a
                                     :label (loc/tr a)})))
        :on-change     (fn [new-value & _]
                         (swap! state assoc :selected-asset-type new-value))}]]
     [modal/right-single-button
      nil
      disabled-button?
      #(on-select! (:selected-asset-type @state) on-close!)
      (loc/tr :select)
      nil]]))
